import { gql } from 'graphql-request'

export const GetSpeciStationDataGql = gql`
  query speciStationDetails($recordNumber: String!) {
    stationDetailsForSpeci(recordNumber: $recordNumber) {
      brand
      tradingName
      rwsStatus
      zqStatus
      zqrxStatus
      isRws
      currentSeasonContracts {
        recordNumber
        contractName
      }
    }
  }
`
